import { isEmailInDomains } from '@order-management/roles';
import { environment } from '../../../environments/environment';

export function useIsZspaceInternalEmail(email: string) {
  return isEmailInDomains(email, environment.internalUserEmailDomains);
}

export default useIsZspaceInternalEmail;
